<template>
  <div class="ui-home">
    <div class="ui-title">
      <div class="titleName">{{title}}</div>
      <div class="titleTime">{{nowDate1}}{{today}}</div>
    </div>
    <div class="ui-content">
      <div class="height155 boxBg width380 marginRight15 marginBottom15">
        <div class="boxTitle">
          <div class="boxTitleLeft">
            <div class="boxTitleArrow"></div>
            <div class="boxTitleName">数据统计</div>
          </div>
          <div class="boxTitleRight pointer" @click="openTab('总服务用户','allUser',`/fetalMonitor/allUser`,{hId:id})">查看详情</div>
        </div>
        <div class="topLeftBox">
          <div class="topleftItem">
            <div class="topleftValue">{{form.nowStatisticsVO.allCount||0}}</div>
            <div class="topleftName">总服务人数</div>
          </div>
          <div class="topleftItem">
            <div class="topleftValue">{{form.nowStatisticsVO.innerHospitalCount||0}}</div>
            <div class="topleftName">院内人数</div>
          </div>
          <div class="topleftItem">
            <div class="topleftValue">{{form.nowStatisticsVO.outHospitalCount||0}}</div>
            <div class="topleftName">院外人数</div>
          </div>
          <div class="topleftItem">
            <div class="topleftValue">{{form.nowStatisticsVO.registerCount||0}}</div>
            <div class="topleftName">设备总数</div>
          </div>
          <div class="topleftItem">
            <div class="topleftValue">{{form.nowStatisticsVO.onlineCount||0}}</div>
            <div class="topleftName">在线设备</div>
          </div>
          <div class="topleftItem">
            <div class="topleftValue">{{form.nowStatisticsVO.offlineCount||0}}</div>
            <div class="topleftName">待机设备</div>
          </div>
        </div>
      </div>
      <div class="height155 boxBg width394 marginRight15 marginBottom15">
        <div class="width394 boxTitle2 textCenter">{{nowDate}}</div>
        <div class="topCenterValueBox width394">
          <div class="text marginRight5">累计</div>
          <div class="numValueBox">{{allCount.length>=7?allCount[6]:0}}</div>
          <div class="numValueBox">{{allCount.length>=6?allCount[5]:0}}</div>
          <div class="numValueBox">{{allCount.length>=5?allCount[4]:0}}</div>
          <div class="numValueBox">{{allCount.length>=4?allCount[3]:0}}</div>
          <div class="numValueBox">{{allCount.length>=3?allCount[2]:0}}</div>
          <div class="numValueBox">{{allCount.length>=2?allCount[1]:0}}</div>
          <div class="numValueBox">{{allCount.length>=1?allCount[0]:0}}</div>
          <div class="text">人次</div>
        </div>
        <div class="topCenterLabelBox">
          <div class="text marginRight5">累计异常</div>
          <div class="text2 marginRight31">{{form.allDataVO.abnormalCount||0}}人次</div>
          <div class="text marginRight5">累计异常率</div>
          <div class="text2 marginRight67" v-if="form?.allDataVO?.allCount>0">{{(form.allDataVO.abnormalCount/form.allDataVO.allCount*100).toFixed(2)}}%</div>
          <div class="text2 marginRight67" v-else>0%</div>
          <div class="text pointer" @click="openTab('累计异常','cumulAbnormal',`/fetalMonitor/cumulAbnormal`,{hId:id})">查看详情</div>
        </div>
      </div>
      <div class="height155 boxBg width380 marginBottom15">
        <div class="boxTitle marginBottom10">
          <div class="boxTitleLeft">
            <div class="boxTitleArrow"></div>
            <div class="boxTitleName">新增人数：{{form.nowOrderList.length}}</div>
          </div>
          <div class="boxTitleRight pointer" @click="openTab('今日新增','newAddition',`/fetalMonitor/newAddition`,{hId:id})">查看详情</div>
        </div>
        <div class="tableBox marginBottom10">
          <div class="tableItem1 tableText">时间</div>
          <div class="tableItem2 tableText">姓名</div>
          <div class="tableItem3 tableText">医院</div>
          <div class="tableItem4 tableText center">状态</div>
        </div>
        <VueSlickCarousel v-if="form.nowOrderList.length>0" v-bind="carouselOptions" class="carousel2">
          <div class="tableBox marginBottom6" v-for="(item,index) in form.nowOrderList" :key="'nowOrder'+index">
            <div class="tableItem1 tableText">{{item.createTime&&new Date(item.createTime).format('hh：mm：ss')||''}}</div>
            <div class="tableItem2 tableText">{{getUserName(item.userName)||''}}</div>
            <div class="tableItem3 tableText">{{item.tbHospitalName||''}}</div>
            <div class="tableItem4 tableText center">{{item.statusName||''}}</div>
          </div>
        </VueSlickCarousel>
      </div>
      <div class="conter-box width380 height423 marginRight15">
        <div class="width380 height190 boxBg marginBottom15">
          <div class="boxTitle marginBottom10">
            <div class="boxTitleLeft">
              <div class="boxTitleArrow"></div>
              <div class="boxTitleName">来源分布</div>
            </div>
            <div class="boxTitleRight pointer" @click="openTab('当前服务用户','source',`/fetalMonitor/source`,{hId:id})">查看详情</div>
          </div>
          <div class="tableBox marginBottom10">
            <div class="tableItem5 tableText">医院名称</div>
            <div class="tableItem6 tableText">区域</div>
            <div class="tableItem7 tableText">服务人数</div>
            <div class="tableItem8 tableText">新增人数</div>
          </div>
          <VueSlickCarousel v-if="form.sourceList.length>0" v-bind="carouselOptions" class="carousel1">
            <div class="tableBox marginBottom10" v-for="(item,index) in form.sourceList" :key="'source'+index">
              <div class="tableItem5 tableText">{{item.hospitalName||''}}</div>
              <div class="tableItem6 tableText">{{item.areaName||''}}</div>
              <div class="tableItem7 tableText center">{{item.allCount||'0'}}</div>
              <div class="tableItem8 tableText center">{{item.nowCount||'0'}}</div>
            </div>
          </VueSlickCarousel>
        </div>
        <div class="width380 height218 boxBg ">
          <div class="boxTitle marginBottom10">
            <div class="boxTitleLeft">
              <div class="boxTitleArrow"></div>
              <div class="boxTitleName">数据分布</div>
            </div>
            <div class="boxTitleRight pointer" v-if="false">查看详情</div>
          </div>
          <div class="lineChartView width380">
            <v-charts ref="line" :option="lineOption" v-chartResize></v-charts>
          </div>
        </div>
      </div>
      <div class="boxBg width394 height423 marginRight15">
        <div class="width394 height423">
          <v-charts ref="map" :option="option" v-chartResize></v-charts>
        </div>
      </div>
      <div class="conter-box width380 height423">
        <div class="width380 height190 boxBg marginBottom15">
          <div class="boxTitle marginBottom10">
            <div class="boxTitleLeft">
              <div class="boxTitleArrow"></div>
              <div class="boxTitleName">监护人次：{{form.nowDataList.length}}</div>
            </div>
            <div class="boxTitleRight pointer" @click="openTab('今日监护','headcount',`/fetalMonitor/headcount`,{hId:id})">查看详情</div>
          </div>
          <div class="tableBox marginBottom10">
            <div class="tableItem1 tableText">时间</div>
            <div class="tableItem2 tableText">姓名</div>
            <div class="tableItem3 tableText">医院</div>
            <div class="tableItem4 tableText center">结果</div>
          </div>
          <VueSlickCarousel v-if="form.nowDataList.length>0" v-bind="carouselOptions" class="carousel1">
            <div class="tableBox marginBottom10" v-for="(item,index) in form.nowDataList" :key="'nowData'+index">
              <div class="tableItem1 tableText">{{item.createTime&&new Date(item.createTime).format('hh：mm：ss')||''}}</div>
              <div class="tableItem2 tableText">{{getUserName(item.userName)||''}}</div>
              <div class="tableItem3 tableText">{{item.tbHospitalName||''}}</div>
              <div class="tableItem4 tableText center" :class="getResultColor(item.tbScore)">{{getResult(item.tbScore)}}</div>
            </div>
          </VueSlickCarousel>
        </div>
        <div class="width380 height218 boxBg ">
          <div class="boxTitle">
            <div class="boxTitleLeft">
              <div class="boxTitleArrow"></div>
              <div class="boxTitleName">结果分布</div>
            </div>
            <div class="boxTitleRight pointer" v-if="false">查看详情</div>
          </div>
          <div class="circleChartView width380">
            <div class="circleChart">
              <v-charts ref="circle" :option="circleOption" v-chartResize></v-charts>
            </div>
            <div class="circlePointView">
              <div class="circlePointItem">
                <div class="point" style="background: #44D7B6;"></div>
                <div class="circlePointText marginRight9" v-if="form?.nowAllDataVO?.allCount>0">正常值 {{(form.nowAllDataVO.normalCount/form.nowAllDataVO.allCount*100).toFixed(2)}}%</div>
                <div class="circlePointText marginRight9" v-else>正常值 0%</div>
                <div class="point" style="background: #E86969;"></div>
                <div class="circlePointText marginRight9" v-if="form?.nowAllDataVO?.allCount>0">异常值 {{(form.nowAllDataVO.abnormalCount/form.nowAllDataVO.allCount*100).toFixed(2)}}%</div>
                <div class="circlePointText marginRight9" v-else>异常值 0%</div>
              </div>
              <div class="circlePointItem">
                <div class="point" style="background: #EFB439;"></div>
                <div class="circlePointText marginRight9" v-if="form?.nowAllDataVO?.allCount>0">可疑值 {{(form.nowAllDataVO.suspicionCount/form.nowAllDataVO.allCount*100).toFixed(2)}}%</div>
                <div class="circlePointText marginRight9" v-else>可疑值 0%</div>
                <div class="point" style="background: #AEB9FE;"></div>
                <div class="circlePointText marginRight9" v-if="form?.nowAllDataVO?.allCount>0">无效值 {{(form.nowAllDataVO.voidCount/form.nowAllDataVO.allCount*100).toFixed(2)}}%</div>
                <div class="circlePointText marginRight9" v-else>无效值 0%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const hospitalName = '鹤壁市妇幼保健院'
const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
var chinaGeoCoordMap = {
  鹤壁市妇幼保健院: [114.2865, 35.7294]
}
var chinaDatas = Object.keys(chinaGeoCoordMap).map((i) => {
  return [{ name: i, value: 1 }]
})
//设置投射点
const scatterPos = chinaGeoCoordMap[hospitalName]
import * as echarts from 'echarts'
import mapGeo from '@/assets/json/hebi.js'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  data () {
    const _this = this
    return {
      id: 60599,
      form: {
        sourceList: [],
        timeList: [],
        nowAllDataVO: {},
        sourceDistributionVO: {},
        nowDataList: [],
        nowStatisticsVO: {},
        allDataVO: {
          allCount: 0,
          abnormalCount: 0
        },
        nowOrderList: []
      },
      nowDate: new Date().format('yyyy.MM.dd hh:mm:ss'),
      nowDate1: new Date().format('yyyy/MM/dd  hh:mm  '),
      today: weeks[new Date().getDay()],
      dataIntervalIndex: null,
      timeIntervalIndex: null,
      arrowImg: require('@/assets/img/arrow.png'),
      pointImg: require('@/assets/img/point.png'),
      lineOption: {
        grid: {
          left: _this.fitChartSize(20),
          right: _this.fitChartSize(30),
          top: _this.fitChartSize(20),
          bottom: _this.fitChartSize(20),
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            '00:00',
            '02:00',
            '04:00',
            '06:00',
            '08:00',
            '10:00',
            '12:00',
            '14:00',
            '16:00',
            '18:00',
            '20:00',
            '22:00',
            '24:00'
          ],
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: 'rgba(255,255,255,1)'
            }
          },
          axisLabel: {
            interval: 1,
            show: true,
            margin: _this.fitChartSize(16),
            fontSize: _this.fitChartSize(12)
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          splitNumber: 5,
          min: 0,
          max: 5,
          type: 'value',
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 'auto',
            show: true,
            verticalAlign: 'center',
            margin: _this.fitChartSize(10),
            fontSize: _this.fitChartSize(12)
          },
          axisLine: {
            show: true,
            onZero: true,
            lineStyle: {
              color: 'rgba(255,255,255,1)'
            }
          }
        },
        series: [
          {
            type: 'line',
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            showSymbol: false,
            itemStyle: {
              borderWidth: _this.fitChartSize(20),
              color: 'rgba(247, 181, 0, 1)'
            }
          }
        ]
      },
      circleOption: {
        series: [
          {
            type: 'pie',
            radius: ['55%', '70%'],
            avoidLabelOverlap: false,
            color: ['#44D7B6', '#EFB439', '#E86969', '#AEB9FE'],
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: [{ value: 0 }, { value: 0 }, { value: 0 }, { value: 0 }]
          }
        ]
      },
      option: {},
      title: hospitalName + '远程胎儿监护中心',
      loading: false,
      carouselOptions: {
        infinite: true, //是否无限循环展示内容
        arrows: false, //展示箭头
        dots: false, //启用点指示器
        slidesToShow: 4, // 同时显示的项目数量
        slidesToScroll: 1, // 每次滚动的项目数量
        autoplay: true, // 自动播放
        autoplaySpeed: 3000, // 切换时间间隔
        vertical: true,
        verticalSwiping: true // 垂直
      }
    }
  },
  components: {
    VueSlickCarousel
  },
  methods: {
    getMapPointByHospitalId () {
      fetch(
        `https://www.hylyljk.com/ymm-common/babyHeartMap/getMapPointByHospitalId?hospitalId=${this.id}`
      ).then((bbb) => {
        bbb.json().then((res) => {
          if (res.code === 1000) {
            res.data.forEach((i) => {
              chinaGeoCoordMap[i.tbHospitalName] = [i.tbLongitude, i.tbLatitude]
            })
            chinaDatas = Object.keys(chinaGeoCoordMap).map((i) => {
              return [{ name: i, value: 1 }]
            })
            this.drawMap()
          }
        })
      })
    },
    getData () {
      fetch(
        `https://www.hylyljk.com/ymm-common/babyHeartMap/getByHospitalId?hospitalId=${this.id}`
      ).then((bbb) => {
        // fetch(`https://www.hylyljk.com/ymm-common/babyHeartMap/getAll`).then(
        //   (bbb) => {
        // fetch(
        //   `http://192.168.100.74:8201/ymm-common/babyHeartMap/getByHospitalId?hospitalId=${this.id}`
        // ).then((bbb) => {
        bbb.json().then((res) => {
          if (res.code === 1000) {
            this.form = res.data
            this.circleOption.series[0].data = [
              { value: this.form.nowAllDataVO.normalCount },
              { value: this.form.nowAllDataVO.suspicionCount },
              { value: this.form.nowAllDataVO.abnormalCount },
              { value: this.form.nowAllDataVO.voidCount }
            ]
            this.circleOption = JSON.parse(JSON.stringify(this.circleOption))
            this.lineOption.series[0].data = [
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0
            ]
            this.form.timeList.map((i) => {
              const segment = this.getTimeSegment(new Date(i))
              this.lineOption.series[0].data[segment] =
                this.lineOption.series[0].data[segment] + 1
            })
            this.lineOption.yAxis.max =
              Math.ceil(Math.max(...this.lineOption.series[0].data) / 5) * 5

            this.lineOption = JSON.parse(JSON.stringify(this.lineOption))
          }
        })
      }).catch(e => {
        this.$message.error('')
      })
    },
    getResult (tbScore) {
      if (tbScore >= 8) {
        return '正常'
      } else if (tbScore >= 5) {
        return '可疑'
      } else if (tbScore >= 1) {
        return '异常'
      } else {
        return '无效'
      }
    },
    getResultColor (tbScore) {
      if (tbScore >= 8) {
        return ''
      } else if (tbScore >= 5) {
        return 'yellow'
      } else if (tbScore >= 1) {
        return 'red'
      } else {
        return ''
      }
    },
    getCircleValue (val1, val2) {
      return (val1 / (val1 + val2)) * 180
    },
    drawMap () {
      const _this = this
      let series = []
        ;[[hospitalName, chinaDatas]].forEach(function (item, i) {
          series.push(
            {
              //绘制一个新地图
              type: 'map',
              map: 'mapGeo',
              zoom: 1,
              z: -1,
              aspectScale: 0.75, //
              itemStyle: {
                normal: {
                  areaColor: 'rgb(111,153,226)',
                  shadowColor: 'rgb(111,153,226)',
                  shadowOffsetX: 5,
                  shadowOffsetY: 10
                }
              }
            },
            //设置指向箭头信息
            {
              type: 'lines',
              colorBy: 'data',
              zlevel: 2,
              effect: {
                show: true,
                period: 4, //箭头指向速度，值越小速度越快
                trailLength: 0, //特效尾迹长度[0,1]值越大，尾迹越长重
                symbol: 'arrow', //箭头图标
                symbolSize: 8 //图标大小
              },
              lineStyle: {
                normal: {
                  width: 1, //尾迹线条宽度
                  opacity: 1, //尾迹线条透明度
                  curveness: 0.3 //尾迹线条曲直度
                }
              },
              data: _this.convertData(item[1])
            },
            // 发射点位置涟漪等效果
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              colorBy: 'data',
              zlevel: 2,
              rippleEffect: {
                //涟漪特效
                period: 4, //动画时间，值越小速度越快
                brushType: 'stroke', //波纹绘制方式 stroke, fill
                scale: 4 //波纹圆环最大限制，值越大波纹越大
              },
              label: {
                normal: {
                  color: '#ffffff',
                  show: true,
                  position: 'right', //显示位置
                  offset: [15, 0], //偏移设置
                  formatter: function (params) {
                    return params.data.name === hospitalName
                      ? ''
                      : params.data.name
                  },
                  fontSize: _this.fitChartSize(14)
                },
                emphasis: {
                  show: true
                }
              },
              symbol: 'circle',
              symbolSize: function (val) {
                return 5 + val[2] * 5 //圆环大小
              },
              itemStyle: {
                normal: {
                  show: true
                }
              },
              data: item[1].map(function (dataItem) {
                return {
                  name: dataItem[0].name,
                  value: chinaGeoCoordMap[dataItem[0].name].concat([
                    dataItem[0].value
                  ])
                }
              })
            },

            //被攻击点
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              zlevel: 2,
              rippleEffect: {
                //涟漪相关
                period: 2,
                brushType: 'stroke',
                scale: 5
              },
              label: {
                normal: {
                  color: '#ffffff',
                  show: true,
                  position: 'top', //显示位置
                  offset: [-20, -16], //偏移设置
                  formatter: function (params) {
                    return hospitalName
                  },
                  fontSize: _this.fitChartSize(14)
                },
                emphasis: {
                  show: true
                }
              },
              itemStyle: {
                normal: {
                  color: 'rgba(60, 207, 232, 1)'
                }
              },
              symbol: 'circle',
              symbolSize: 10, //圆圈大小
              data: [
                {
                  name: hospitalName,
                  value: chinaGeoCoordMap[item[0]].concat([10])
                }
              ]
            }
          )
        })
      this.$nextTick(() => {
        echarts.registerMap('mapGeo', mapGeo)
        this.option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}'
          },
          color: [
            'rgba(60, 207, 232, 0)',
            'rgba(244, 203, 99, 1)',
            'rgba(218, 110, 224, 1)',
            'rgba(109, 212, 0, 1)',
            'yellow',
            'rgba(242, 125, 99, 1)'
          ],
          series: series,
          geo: {
            show: true,
            //设置中心点
            map: 'mapGeo',
            roam: false, //是否允许缩放，拖拽
            zoom: 1, //初始化大小
            //缩放大小限制
            scaleLimit: {
              min: 0.1, //最小
              max: 12 //最大
            },
            //各个省份模块样式设置
            itemStyle: {
              normal: {
                areaColor: '#0D2140', //背景色
                color: 'red', //字体颜色
                borderColor: '#2D4264',
                borderWidth: 2
              }
            },
            //高亮状态
            emphasis: {
              itemStyle: {
                areaColor: '#0D2140'
              },
              label: {
                show: false,
                color: '#fff'
              }
            },
            // 显示层级
            z: 10
          }
        }
      })
    },
    convertData (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var dataItem = data[i]
        var fromCoord = chinaGeoCoordMap[dataItem[0].name]
        var toCoord = scatterPos
        if (fromCoord && toCoord) {
          res.push([
            { coord: fromCoord, value: dataItem[0].value },
            { coord: toCoord }
          ])
        }
      }
      return res
    },
    timeIntervalChange () {
      this.nowDate = new Date().format('yyyy.MM.dd hh:mm:ss')
      this.nowDate1 = new Date().format('yyyy/MM/dd  hh:mm  ')
      this.today = weeks[new Date().getDay()]
    },
    getTimeSegment (date) {
      return Math.floor(date.getHours() / 2) + 1
    },
    getUserName (name) {
      if (name?.length === 2) {
        return `${name[0]}*`
      } else if (name?.length > 2) {
        return `${name[0]}*${name[name.length - 1]}`
      } else {
        return name
      }
    }
  },
  mounted () {
    this.getMapPointByHospitalId()
  },
  computed: {
    allCount () {
      return (this.form.allDataVO.allCount + '').split('').reverse()
    },
    ...mapGetters([
      'lastBreadCrumb',
      'refreshPage'
    ])
  },
  created () {
    this.timeIntervalIndex = setInterval(this.timeIntervalChange, 1000)
    this.dataIntervalIndex = setInterval(this.getData, 1000 * 60 * 5)
    this.getData()
  },
  beforeDestroy () {
    this.timeIntervalIndex && clearInterval(this.timeIntervalIndex)
    this.timeIntervalIndex = null
    this.dataIntervalIndex && clearInterval(this.dataIntervalIndex)
    this.dataIntervalIndex = null
  }
}
</script>
<style lang="scss" >
@import "@/assets/css/home.scss";
</style>